// design system imports
if (document.querySelector('.js-ds-image-carousel')) {
  import(/* webpackChunkName: "ds-image-carousel" */ './design-system/ds-image-carousel');
}

if (document.querySelector('.js-nav-inner')) {
  import(/* webpackChunkName: "ds-nav-inner" */ './design-system/ds-nav-inner');
}

if (document.querySelector('.js-ds-tab')) {
  import(/* webpackChunkName: "ds-tabs" */ './design-system/ds-tabs');
}

// mx fuel imports
if (document.querySelector('[data-autoplay-video]')) {
  import(/* webpackChunkName: "autoplay-video" */ './mx-fuel/autoplay-video');
}

if (document.querySelector('.js-content-carousel')) {
  import(/* webpackChunkName: "content-carousel" */ './mx-fuel/content-carousel');
}

if (document.querySelector('.js-transform-animation')) {
  import(/* webpackChunkName: "transform-animation" */ './mx-fuel/transform-video-modal');
}

if (document.querySelector('.js-read-more-paragraph')) {
  import(/* webpackChunkName: "read-more-paragraph" */ './mx-fuel/read-more-paragraph');
}

if (document.querySelector('.js-jump-page-nav')) {
  import(/* webpackChunkName: "jump-page-nav" */ './mx-fuel/jump-page-nav');
}

if (document.querySelector('.js-mxfuel-accordion')) {
  import(/* webpackChunkName: "mx-fuel-accordion" */ './mx-fuel/accordion');
}

if (document.querySelector('.js-mxfuel-video-modal')) {
  import(/* webpackChunkName: "mxfuel-video-modal" */ './mx-fuel/video-modal');
}

if (document.querySelector('.js-mxfuel-product-slider')) {
  import(/* webpackChunkName: "mxfuel-product-slider" */ './mx-fuel/product-slider');
}

if (document.querySelector('.js-packout-scrolling-carousel')) {
  import(/* webpackChunkName: "packout-scrolling-carousel" */ './packout/scrolling-carousel');
}

if (document.querySelector('.js-packout-video')) {
  import(/* webpackChunkName: "packout-video-bg" */ './packout/video-bg');
}

if (document.querySelector('.js-packout-build-kit')) {
  import(/* webpackChunkName: "packout-build-kit" */ './packout/build-kit');
}

if (document.querySelector('.js-packout-reviews-carousel')) {
  import(/* webpackChunkName: "packout-reviews-carousel" */ './packout/reviews-carousel');
}

if (document.querySelector('.js-mx-scrolling')) {
  import(/* webpackChunkName: "mx-image-scroller" */ './mx-fuel/scroller');
}

if (document.querySelector('.js-product-select')) {
  import(/* webpackChunkName: "product-selects" */ './product-selects');
}

if (document.querySelector('.js-zero-emissions-tabs')) {
  import(/* webpackChunkName: "zero-emissions-tabs" */ './mx-fuel/js-zero-emissions-tabs');
}

if (document.querySelector('.js-mx-product-comparison')) {
  import(/* webpackChunkName: "mx-product-comparison" */ './mx-fuel/product-comparison');
}

if (document.querySelector('.js-mx-fuel-spec-table')) {
  import(/* webpackChunkName: "mx-fuel-spec-table" */ './mx-fuel/spec-table');
}

if (document.querySelector('.js-mxf-banner')) {
  import(/* webpackChunkName: "mx-fuel-teaser" */ './mx-fuel/InteractiveTeaser');
}

// imports
if (document.querySelector('[data-anim]')) {
  import(/* webpackChunkName: "netc-aos" */ './init-netc-aos');
}

if (document.querySelector('[data-hover-element]')) {
  import(/* webpackChunkName: "hover-exclude" */ './init-hover-exclude');
}

if (document.querySelector('.js-vectary')) {
  import(/* webpackChunkName: "vectary-viewer" */ './mx-fuel/vectary-model');
}

if (document.querySelector('.js-pdf-modal')) {
  const qs = window.location.search;

  if (qs.length > 0) {
    // Lazy load the querystring plugin
    import('querystring').then(module => {
      const querystring = module.default;

      const params = querystring.parse(qs.split('?')[1]);

      // Then lazy load the PDF work if we have a PDF in the URL
      if (params.pdfurl && params.pdfurl.length > 0) {
        import(/* webpackChunkName: "pdfs" */ './init-pdfs');
      }
    });
  }
}

if (document.querySelector('.js-stack-adapt')) {
  import(/* webpackChunkName: "stack-adapt" */ './init-stack-adapt');
}

if (document.querySelector('.js-disable-right-click')) {
  import(/* webpackChunkName: "disable-right-click" */ './init-right-click');
}

if (document.querySelector('.js-packout-share--facebook')) {
  import(/* webpackChunkName: "packout-share" */ './packout/share');
}

if (document.querySelector('.js-defer-elfsight')) {
  import(/* webpackChunkName: "elfsight" */ './init-elfsight');
}

if (document.querySelector('.js-ds-360')) {
  import(/* webpackChunkName: "ds-interactive-360" */ './design-system/ds-interactive-360');
}

if (document.querySelector('.js-select')) {
  import(/* webpackChunkName: "selects" */ './init-selects');
}

if (document.querySelector('.js-ds-file-container')) {
  import(/* webpackChunkName: "file-upload" */ './init-file-upload');
}

if (document.querySelector('.js-promotion-card')) {
  import(/* webpackChunkName: "promotion-cards" */ './init-promotion-cards');
}

if (document.querySelector('.js-promo-trigger-modal')) {
  import(/* webpackChunkName: "promo-modal" */ './init-promo-modal');
}

if (document.querySelector('.js-product-modal')) {
  import(/* webpackChunkName: "product-modal" */ './init-product-modal');
}

if (document.querySelector('.js-ds-video-thumb-carousel')) {
  import(/* webpackChunkName: "video-thumb-carousel" */ './init-video-thumb-carousel');
}

if (document.querySelector('.js-mx-fuel-download-selector')) {
  import(/* webpackChunkName: "mx-fuel-downloads" */ './mx-fuel/downloads');
}

if (document.querySelector('.js-mxf-store-locator') && document.querySelector('.js-mxf-form-container')) {
  import(/* webpackChunkName: "mx-fuel-form-anchor" */ './mx-fuel/formAnchor');
}

if (document.querySelector('.js-mxf-request-a-demo') && document.querySelector('.js-mxf-form-container')) {
  import(/* webpackChunkName: "mx-fuel-demo-anchor" */ './mx-fuel/demoAnchor');
}

if (document.querySelector('.js-es-step-carousel')) {
  import(/* webpackChunkName: "es-step-carousel" */ './e-service/init-step-carousel');
}

if (document.querySelector('[data-ga-social-link]')) {
  import(/* webpackChunkName: "ga-social-link" */ './tracking/social-links');
}

if (document.querySelector('.js-countdown')) {
  import(/* webpackChunkName: "countdown" */ './init-countdown');
}

if (document.querySelector('.js-match-height-segment')) {
  import(/* webpackChunkName: "match-height" */ './init-match-height');
}

if (document.querySelector('.js-flipsnack')) {
  import(/* webpackChunkName: "flipsnack" */ './init-flipsnack');
}

if (document.querySelector('[data-laser-tab]')) {
  import(/* webpackChunkName: "laser-tabs" */ './lasers/toggle-tabbed');
}

if (document.querySelector('[video-in-view]')) {
  import(/* webpackChunkName: "video-in-view" */ './init-video-in-view');
}

if (document.querySelector('.js-preview-tab')) {
  import(/* webpackChunkName: "tab-preview" */ './lasers/tab-preview');
}

if (document.querySelector('.js-laser-banner')) {
  import(/* webpackChunkName: "laser-banner" */ './lasers/laser-banner');
}

if (document.querySelector('.js-home-carousel, .js-recently-viewed-btn')) {
  import(/* webpackChunkName: "js-home-carousel" */ './init-home-carousel');
}

if (document.querySelector('.js-prevent-title-change')) {
  import(/* webpackChunkName: "prevent-title-change" */ './init-prevent-title-change');
}

if (document.querySelector('.js-submit-disable')) {
  import(/* webpackChunkName: "js-submit-disable" */ './init-form-submit');
}
